import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { NavLink } from 'react-router-dom';

import { ChannelAvatar, HelperTooltip } from '@/components';
import { Channel } from '@/views/Channel/types';

import { ProposalStatusTags } from '../ProposalStatusTags';
import { FeedArticle } from '../..';
import styles from './index.module.scss';

const stopPropagation = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.stopPropagation();
};

const OriginalTag = () => {
  const { t } = useTranslation();
  return (
    <HelperTooltip title={t('ArticleContent.originalTip')}>
      <span className={styles.originalTag}>{t('ArticleContent.original')}</span>
    </HelperTooltip>
  );
};

const ChannelTag = ({ data }: { data: Channel }) => {
  return (
    <NavLink to={`/channel/${data.id}`} onClick={stopPropagation}>
      <div className={styles.channelTag}>
        <ChannelAvatar size={16} {...data} /> /{data.id}
      </div>
    </NavLink>
  );
};

export const TagList = ({ article }: { article: FeedArticle }) => {
  if (!article?.is_original && isEmpty(article?.official_list) && !article?.channel) {
    return null;
  }
  return (
    <div className={styles.tagContainer}>
      {article?.channel ? <ChannelTag data={article.channel} /> : null}
      {article?.is_original && <OriginalTag />}
      {!isEmpty(article?.official_list) && (
        <ProposalStatusTags statusList={article.official_list} />
      )}
    </div>
  );
};
